document.addEventListener("DOMContentLoaded", function () {
    const container = document.getElementById("recently-viewed-products");
    if (!container) return;

    const currentHandle = document.getElementById("ProductMeta")?.dataset.productHandle;
    let history = JSON.parse(localStorage.getItem("viewedProducts") || "[]").filter(Boolean);
    // 重複回避
    history = history.filter(h => h !== currentHandle);
    history.unshift(currentHandle);
    localStorage.setItem("viewedProducts", JSON.stringify(history));

    // 今見てる商品は除外
    history = history.filter(handle => handle !== currentHandle);

    const limit = 10;
    const handles = history.slice(0, limit);

    Promise.all(
        handles.map(handle =>
            fetch(`/products/${handle}?section_id=product-loop-section`)
            .then(res => res.text())
            .then(html => {
                const doc = new DOMParser().parseFromString(html, "text/html");
                const card = doc.querySelector(".swiper-slide");
                return card?.outerHTML || "";
            })
            .catch(err => {
                console.warn("Fetch error:", err);
                return "";
            })
        )
    ).then(cards => {
        const validCards = cards.filter(c => c.trim() !== "");
        const cardCount = validCards.length;

    if (cardCount === 0) return;

    const isSlider = cardCount > 0; // 2件以上でスライダー
    const centerClass = cardCount < 5 ? 'swiper-center' : '';
    const wrapperClasses = isSlider
        ? `swiper-wrapper swiper-wrapper-recommended-products ${centerClass}`
        : 'collection-products';

    const outerHTML = `
        <div class="product-recommendations relative row last">
            <h2 class="text-center">最近チェックしたアイテム</h2>
            <div class="${isSlider ? 'swiper-container plus-grid' : 'twelve center'} product-loop product-loop-product-template recently-viewed-swiper" ${isSlider ? 'id="swiper-carousel-recently-viewed-products-grid"' : ''}>
            <div class="${wrapperClasses}">
                ${validCards.join("")}
            </div>

            ${
                isSlider
                ? `<div id="swiper-pagination-recently-viewed-products" class="swiper-pagination relative bottompad-quarter">
                        <div id="swiper-button-prev-recently-viewed-products" class="tabindex swiper-button-prev icon icon-chevron-left" role="button"></div>
                        <div id="swiper-button-next-recently-viewed-products" class="tabindex swiper-button-next icon icon-chevron-right" role="button"></div>
                    </div>`
                : ''
            }
            </div>
        </div>
    `;

    container.innerHTML = outerHTML;

    // Swiper 初期化
    if (isSlider && typeof Swiper !== 'undefined') {
        new Swiper(".recently-viewed-swiper", {
            loop: false,
            slidesPerView: 2,
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    centeredSlides: true,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 3,
                    centeredSlides: false,
                },
                1024: {
                    slidesPerView: 4,
                    centeredSlides: false,
                }
            }
        });
    }
});
});
